import AuthContainer from '../../components/AuthContainer';
import { Text } from '../../components/SecondaryMarket';
import { fontSizes } from '../../constants/constants';
import icons from '../../constants/icons';
import { InvestorCard } from './components';
import ChooseInvestorTypeFunctional from './index.function';

const ChooseInvestorType = () => {
  const { TextWeight, navigate, getContentKey, isArabic } = ChooseInvestorTypeFunctional();

  return (
    <AuthContainer className={'min-w-full md:min-w-[500px] lg:min-w-[600px] px-8 md:px-20'}>
      <Text text={getContentKey('choose_investor_type')} weight={TextWeight.headingRegular} className={'text-dark-blue'} size={fontSizes.h30} />
      <a href={`${process.env.REACT_APP_OPEN_ACCOUNT_LINK}${isArabic ? 'ar' : 'en'}`}>
      <InvestorCard
        title={getContentKey("individual")}
        description={getContentKey("individual_account_opening")}
        icon={icons.individual_icon}
      />

      </a>
      <InvestorCard
        title={getContentKey('institutional')}
        description={getContentKey('institutions_account_opening')}
        icon={icons.institutional_icon}
        onPress={() => navigate('/create-corporate-account')}
      />
    </AuthContainer>
  );
};

export default ChooseInvestorType;
